/**
 * A Scale Charge charges a Connected Account and credits the Platform account's wallet.
 *
 * @see https://www.airwallex.com/docs/api/scale/charges/create
 * @see https://www.airwallex.com/docs/api/scale/charges/retrieve
 */
export enum ConnectedAccountChargeStatus {
  NEW = 'NEW',
  PENDING = 'PENDING',
  SETTLED = 'SETTLED',
  SUSPENDED = 'SUSPENDED',
  FAILED = 'FAILED',
}

export enum ConnectedAccountChargeReason {
  WAGES_SALARY = 'wages_salary',
  DONATION_CHARITABLE_CONTRIBUTION = 'donation_charitable_contribution',
  PERSONAL_REMITTANCE = 'personal_remittance',
  TRANSFER_TO_OWN_ACCOUNT = 'transfer_to_own_account',
  PENSION = 'pension',
  FAMILY_SUPPORT = 'family_support',
  LIVING_EXPENSES = 'living_expenses',
  EDUCATION_TRAINING = 'education_training',
  TRAVEL = 'travel',
  INVESTMENT_PROCEEDS = 'investment_proceeds',
  INVESTMENT_CAPITAL = 'investment_capital',
  LOAN_CREDIT_REPAYMENT = 'loan_credit_repayment',
  TAXES = 'taxes',
  GOODS_PURCHASED = 'goods_purchased',
  BUSINESS_EXPENSES = 'business_expenses',
  MEDICAL_SERVICES = 'medical_services',
  PROFESSIONAL_BUSINESS_SERVICES = 'professional_business_services',
  TECHNICAL_SERVICES = 'technical_services',
  OTHER_SERVICES = 'other_services',
  CONSTRUCTION = 'construction',
  FREIGHT = 'freight',
  REAL_ESTATE = 'real_estate',
}

export type CreateConnectedAccountChargeRequest = {
  // The amount of the charge in `currency`, representing how much to charge.
  // Airwallex expects this as a string (e.g. "10000").
  amount: string
  // The currency of the charge (3-letter ISO-4217 code).
  currency: string
  // The reason for the charge instruction.
  reason: ConnectedAccountChargeReason
  // A user specified reference that will be displayed to the beneficiary. 1-140 characters long.
  reference: string
  // A unique request ID specified by the client. 1-50 characters long.
  request_id: string
  // The Airwallex account unique identifier of the connected account to charge.
  source: string
}

export type ConnectedAccountChargeResponse = {
  amount: number
  created_at: string
  currency: string
  fee: number
  id: string
  reason: ConnectedAccountChargeReason
  reference: string
  request_id: string
  short_reference_id: string
  source: string
  status: ConnectedAccountChargeStatus
  updated_at: string
}
